// Работа с полями формы. Добавление классов, работа с placeholder

const formsOld = {
    form: () => {
        const forms = document.querySelectorAll('._form'),
            inputs = document.querySelectorAll('._form-input');

        if (forms.length) {
            const message = {
                uk: {
                    loading: 'Відправка...',
                    success: 'Дякуємо, скоро подзвонимо!',
                    failure: 'Щось пішло не так',
                    fill_in_field: 'Заповніть, будь ласка, поля'
                },
                en: {
                    loading: 'Sending...',
                    success: 'Sent! We will contact you soon',
                    failure: 'Something went wrong',
                    fill_in_field: 'Please fill in the fields'
                },
                ru: {
                    loading: 'Отправка...',
                    success: 'Отправлено! Мы скоро свяжемся с Вами',
                    failure: 'Что-то пошло не так',
                    fill_in_field: 'Пожалуйста, заполните поля'
                }
            }
            let lang = document.documentElement.lang;
            if (lang === 'ru-RU') {
                lang = 'ru';
            }
            if (lang === 'en-US') {
                lang = 'en';
            }
            if (lang === 'uk-UA') {
                lang = 'ua';
            }
            const textStringsLang = message[lang];

            const formAddError = (field) => {
                field.classList.add('_error');
            }

            const formRemoveError = (field) => {
                field.classList.remove('_error');
            }

            const emailCheck = (field) => {
                return !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(field.value);
            }

            const phoneCheck = (field) => {
                // Видалити всі символи, що не є цифрами
                const cleaned = field.value.replace(/[^\d]/g, '');

                // Перевірка на наявність цифр
                if (cleaned.length === 0) {
                    field.value = '';
                    return;
                }

                // Форматування до +380 (XX) XXX-XX-XX
                let formatted;
                if (cleaned.length <= 12) {
                    // Додаємо +380, якщо номер не починається з +380
                    if (cleaned.startsWith('0')) {
                        formatted = cleaned.replace(/^0/, '+380 ');
                    } else if (!cleaned.startsWith('380')) {
                        formatted = '+380 ' + cleaned;
                    } else {
                        formatted = '+' + cleaned;
                    }

                    // Додаємо пробіли та дефіси для формату +380 (XX) XXX-XX-XX
                    formatted = formatted.replace(/^(\+380)(\d{2})(\d{3})(\d{2})(\d{2})$/, '$1 ($2) $3-$4-$5');
                } else {
                    formatted = cleaned; // Якщо номер більше 12 цифр, просто відображаємо його як є
                }

                // Оновлюємо значення поля з відформатованим номером
                field.value = formatted;
            };

            const validateMinLength = (field) => {
                const minLength = 10;
                // Видаляємо всі символи, які не є цифрами або знаком '+', при цьому залишаємо лише один '+'
                const cleaned = field.value.replace(/(?!^\+)[^\d]/g, '');

                // Перевіряємо, чи кількість символів (цифр і можливий '+') >= мінімальній довжині
                return cleaned.length >= minLength;
            };



            function formValidate(form) {
                let error = 0;

                const phoneInput = form.querySelector('input[type="tel"]'),
                    emailInput = form.querySelector('input[type="email"]'),
                    reqInputs = form.querySelectorAll('._req');

                form.querySelectorAll('input').forEach(input => {
                    formRemoveError(input);
                });

                if (phoneInput) {
                    if (!validateMinLength(phoneInput)) {
                        formAddError(phoneInput);
                        error++;
                    }
                    phoneInput.addEventListener('input', (e) => {
                        //phoneInput.value = phoneInput.value.replace(/\D/, '');
                        phoneCheck(e.target)
                    });
                    if (phoneCheck(phoneInput)) {
                        formAddError(phoneInput);
                        error++;
                    }
                }

                /*if (emailInput) {
                    if (emailCheck(emailInput)) {
                        formAddError(emailInput);
                        error++;
                    }
                }*/

                if (reqInputs) {
                    reqInputs.forEach(item => {
                        if (item.value === '') {
                            formAddError(item);
                            error++;
                        }
                    })
                }
                if (phoneInput && emailInput) {
                    if (phoneInput.value === '' && emailInput.value === '') {
                        if (phoneCheck(phoneInput)) {
                            formAddError(phoneInput);
                            error++;
                        }
                        if (emailCheck(emailInput)) {
                            formAddError(emailInput);
                            error++;
                        }
                    }
                }


                return error;
            }

            const postData = async (url, data) => {
                //console.log(data)

                let result = await fetch(url, {
                    method: 'POST',
                    body: data
                });

                return await result.text();
            }

            const clearInputs = () => {
                inputs.forEach(item => {
                    item.value = '';
                    item.setAttribute('value', '');
                })
            }

            forms.forEach(item => {

                const policy = item.querySelector('[name="policy"]');

                if (policy) {
                    item.querySelector('[type="submit"]').disabled = true;
                    policy.addEventListener('click', () => {
                        if (policy.checked) {
                            item.querySelector('[type="submit"]').disabled = false;
                        } else {
                            item.querySelector('[type="submit"]').disabled = true;
                        }
                    });
                }

                item.addEventListener('input', () => {
                    formValidate(item);
                })

                item.addEventListener('submit', (e) => {
                    if (item.classList.contains('_pwm-send')) {
                        e.preventDefault();

                        // grecaptcha
                        grecaptcha.enterprise.ready(async () => {
                            const token = await grecaptcha.enterprise.execute('6LcR1xgqAAAAAEOOZm99mMe_pFu0o8UVYcxZnqXz', { action: 'LOGIN' });


                            let statusMessage = document.createElement('div');
                            statusMessage.classList.add('_form__status');

                            // if isset element FormStatus = remove
                            if (item.querySelector('._form__status')) {
                                item.querySelector('._form__status').remove();
                            }

                            item.appendChild(statusMessage);

                            let formStatus = item.querySelector('._form__status');
                            formStatus.classList.remove('_form__status-error');
                            formStatus.classList.remove('_form__status-ok');
                            statusMessage.textContent = textStringsLang.loading;

                            let error = formValidate(item);

                            //console.log(error);
                            if (error === 0) {
                                const formData = new FormData(item);

                                postData(`/wp-content/themes/inhome/sendmail.php`, formData)
                                    .then(result => {
                                        //console.log(result)
                                        item.classList.add('_ok');
                                        statusMessage.classList.remove('_form__status-error');
                                        statusMessage.classList.add('_form__status-ok');


                                        const dataload = item.dataset.load;
                                        dataload ? window.location.href = `/${dataload}/` : statusMessage.textContent = textStringsLang.success;
                                        //statusMessage.textContent = textStringsLang.success

                                    })
                                    .catch(() => {
                                        statusMessage.classList.add('_form__status-error');
                                        statusMessage.textContent = textStringsLang.failure;

                                        clearInputs();

                                    })
                                    .finally(() => {
                                        clearInputs();
                                    });
                            } else {
                                statusMessage.classList.add('_form__status-error');
                                statusMessage.textContent = textStringsLang.fill_in_field;

                                item.addEventListener('input', () => {
                                    error = formValidate(item);
                                })
                            }
                        }); // grecaptcha
                    }
                })
            })

        }
    },

    baseInfoForm: () => {
        const forms = document.querySelectorAll('._form');
        if (forms.length > 0) {
            forms.forEach(form => {
                let infoField = form.querySelector('[name="info"]');
                if (infoField) {
                    const pageTitle = document.title;
                    if (infoField.tagName.toLowerCase() === 'input') {
                        infoField.value = `${infoField.value} | Page: ${pageTitle}`;
                    } else {
                        infoField.textContent = `${infoField.value} | Page: ${pageTitle}`;
                    }

                }
            })
        }
    },

    infofForm: (elem, inform) => {
        if (elem) {
            const input = elem.querySelector('[name="info"]');

            const addInfo = (newValue) => {
                if (input.tagName.toLowerCase() === 'input') {
                    input.setAttribute('value', newValue)
                } else {
                    input.textContent = newValue;
                }
            }

            if (input) {
                const regex = /\/([^\/]+)\//g; // Шукає текст між двома слешами
                if (regex.test(input.value)) {
                    const newValue = input.value.replace(regex, inform);

                    addInfo(newValue)

                } else {
                    const newValue = input.value + ' ' + inform;

                    addInfo(newValue)

                }

            }

        }
    }

}


/**
 * 1. Вибрати всі, крім (по імені)
 * 2. Валідувати чи ні (валідація може бути і в php)
 * 3. Відправляти чи ні
 * 4. Шлях до php файлу
 * 5. Відправляти в телеграм із скрипта, без відправки на пошту
 * 6. Маска телефону
 * 7. Перевірка правильності E-mail
 * 8. Перевірка на заповнення
 * 9. Перевірка на роботів
 * 10. Перевірка телефону
 * 11. Сповіщення про відправку тут же, в модалці, на новій сторінці (вказати урл)
 * 12. Відправляти у вайбер
 * 13. Чекбокси політики конфіденційності - перевірка
 * 14. Функція після успішної відправки (для додаткових приколів, типу слідкування з гуглтегів)
 * 
 * Так що це потрібно переписати, як модуль з класомі
 */
/*const forms = {
    sendForm: (not) => {
        console.log('Smile :)');
        const forms = document.forms;
        console.log(forms);
        if (forms.length) {
            for (const form of forms) {
                //if (form.getAttribute('name') != not) {
                //if (!not.indexOf(form.getAttribute('name'))) {
                console.log(form.getAttribute('name'));
                form.addEventListener('submit', e => {
                    const form = e.target;
                    //formSubmitAction(form, e);
                });
                form.addEventListener('reset', e => {
                    const form = e.target;
                    //formValidate.formClean(form);
                });
                //}
            }
        }
    },
}*/

export const form = formsOld.form;
export const infoForm = formsOld.infofForm;
export const baseInfoForm = formsOld.baseInfoForm;
//export const sendForm = forms.sendForm;